// apicore
import { APICore } from '../../helpers/api/apiCore';

// constants
import { AuthActionTypes } from './constants';

const api = new APICore();
const s_user = api.getLoggedInUserFromCookie()
const userDetail = api.getLoggedInUser()
const s_userDetails = { userId: userDetail.nameid, userName: userDetail.unique_name, fullName: userDetail.fullName, mobile: userDetail.mobile, lastLogin: userDetail.lastLoginInfo, role: userDetail.role, defaultPage: userDetail.defaultPage, isOptLogin: userDetail.isOptLogin }

const INIT_STATE = {
    user: s_user,//api.getLoggedInUser(),
    userDetails: s_userDetails,
    loading: false,
    isOPT: false,
    phoneNumber: ''
};

interface UserData {
    id: number;
    email: string;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    role: string;
    token: string;
}

interface AuthActionType {
    type:
    | AuthActionTypes.API_RESPONSE_SUCCESS
    | AuthActionTypes.API_RESPONSE_ERROR
    | AuthActionTypes.LOGIN_USER
    | AuthActionTypes.LOGIN_USER_WITH_CODE
    | AuthActionTypes.LOGIN_USER_WITH_SSO
    | AuthActionTypes.LOGOUT_USER
    | AuthActionTypes.RESET;
    payload: {
        actionType?: string;
        data?: UserData | {};
        details?: {},
        error?: string;
        errorStatus?: string
    };
}

interface State {
    user?: UserData | {};
    details?: {};
    loading?: boolean;
    value?: boolean;
}

const Auth = (state: State = INIT_STATE, action: AuthActionType): any => {
    switch (action.type) {
        case AuthActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AuthActionTypes.LOGIN_USER: {
                    return {
                        ...state,
                        user: action.payload.data,
                        userDetails: action.payload.details,
                        userLoggedIn: true,
                        loading: false,
                        userLogout: false,
                        phoneNumber: '',
                        isOPT: false,
                        error: "",
                        errorStatus: "",
                    };
                }

                case AuthActionTypes.OPT_USER: {
                    return {
                        ...state,
                        phoneNumber: action.payload.details,
                        isOPT: true,
                        loading: false,
                        error: "",
                        errorStatus: "",
                    };
                }
                case AuthActionTypes.SIGNUP_USER: {
                    return {
                        ...state,
                        loading: false,
                        userSignUp: true,
                    };
                }
                case AuthActionTypes.LOGOUT_USER: {
                    return {
                        ...state,
                        user: null,
                        userDetails: null,
                        loading: false,
                        userLogout: true,
                        userLoggedIn: false,

                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD: {
                    return {
                        ...state,
                        resetPasswordSuccess: action.payload.data,
                        loading: false,
                        passwordReset: true,
                    };
                }
                default:
                    return { ...state };
            }

        case AuthActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AuthActionTypes.LOGIN_USER: {
                    return {
                        ...state,
                        user: null,
                        userDetails: null,
                        error: action.payload.error,
                        errorStatus: action.payload.errorStatus,
                        userLoggedIn: false,
                        loading: false,
                    };
                }
                case AuthActionTypes.SIGNUP_USER: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        userSignUp: false,
                        loading: false,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        passwordReset: false,
                    };
                }
                default:
                    return { ...state };
            }

        case AuthActionTypes.LOGIN_USER:
            return { ...state, loading: true, userLoggedIn: false };

        case AuthActionTypes.LOGIN_USER_WITH_CODE:
            return { ...state, loading: true, userLoggedIn: false };

        case AuthActionTypes.LOGIN_USER_WITH_SSO:
            return { ...state, loading: true, userLoggedIn: false };

        case AuthActionTypes.LOGOUT_USER:
            return { ...state, loading: true, userLogout: false };
        case AuthActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                userSignUp: false,
                userLoggedIn: false,
                passwordReset: false,
                passwordChange: false,
                resetPasswordSuccess: null,
            };
        default:
            return { ...state };
    }
};

export default Auth;
